import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';

import AssignmentIcon from '@material-ui/icons/Assignment';
import StarIcon from '@material-ui/icons/Star';
import MailIcon from '@material-ui/icons/Mail';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import HomeIcon from '@material-ui/icons/Home';
import SetupIcon from '@material-ui/icons/Settings';
import WebIcon from '@material-ui/icons/Web';

import * as routes from '../../constants/routes';
import { startEditAdmin } from '../../store/actions/admin';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes,
} from 'components/admin/Help';

const styles = theme => ({
  selected: {
    backgroundColor: "#E8EAF6",
  },
});

const mapStateToProps = (state) => ({
  admin: state.adminState,
});

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (update) => dispatch(startEditAdmin(update))
});

const selectedStyle = (classes, selected) => {
  if (selected) {
    return classes.selected;
  }
}

const resetAdmin = (route, action, history, selectedDrawerItem) => {
  action({
    invoice: null,
    client: null,
    bid: null,
    project: null,
    selectedDrawerItem: selectedDrawerItem,
  });
  history.push(route);
};


//TODO: refactor how admin state is being reset -- don't want
//to have to always specify which states to set to null
export const PrimaryDrawerItems = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(({history, startEditAdmin}) => {
  return (
    <List>
      <ListItem button onClick={() => resetAdmin(routes.START, startEditAdmin, history)}>
        <ListItemIcon>
          <DirectionsRunIcon />
        </ListItemIcon>
        <ListItemText primary="Getting Started" />
      </ListItem>
    </List>
  );
});

export const SecondaryDrawerItems = compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(({ classes, admin, history, startEditAdmin}) => {
  return (
    <List>
      <ListItem
        className={selectedStyle(classes, admin.selectedDrawerItem === "Bids")}
        button
        onClick={() => resetAdmin(routes.BIDS, startEditAdmin, history, "Bids")}
      >
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Bids" />
      </ListItem>
      <ListItem
        className={selectedStyle(classes, admin.selectedDrawerItem === "Jobs")}
        button
        onClick={() => resetAdmin(routes.JOBS, startEditAdmin, history, "Jobs")}
      >
        <ListItemIcon>
          <ThumbUpIcon />
        </ListItemIcon>
        <ListItemText primary="Jobs" />
      </ListItem>
      <Tooltip type={TooltipTypes.INVOICE_MENU_ITEM} placement="right">
        <ListItem
          className={selectedStyle(classes, admin.selectedDrawerItem === "Invoices")}
          button
          onClick={() => {
            resetAdmin(routes.INVOICES, startEditAdmin, history, "Invoices");
            helpDispatch();
          }}
        >
          <ListItemIcon>
            <AttachMoneyIcon />
          </ListItemIcon>
          <ListItemText primary="Invoices" />
        </ListItem>
      </Tooltip>
    </List>
  );
});

export const TertiaryDrawerItems = compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(({classes, admin, history, startEditAdmin}) => {
  return(
    <List>
      <ListItem
        className={selectedStyle(classes, admin.selectedDrawerItem === "Website")}
        button
        onClick={() => resetAdmin(routes.WEBSITE, startEditAdmin, history, "Website")}
      >
        <ListItemIcon>
          <WebIcon />
        </ListItemIcon>
        <ListItemText primary="Website" />
      </ListItem>
      <ListItem
        className={selectedStyle(classes, admin.selectedDrawerItem === "Account")}
        button
        onClick={() => resetAdmin(routes.ACCOUNT, startEditAdmin, history, "Account")}
      >
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Account" />
      </ListItem>
      <ListItem
        className={selectedStyle(classes, admin.selectedDrawerItem === "Setup")}
        button
        onClick={() => resetAdmin(routes.SETUP, startEditAdmin, history, "Setup")}
      >
        <ListItemIcon>
          <SetupIcon />
        </ListItemIcon>
        <ListItemText primary="Setup" />
      </ListItem>
    </List>
  );
});

export const QuaternaryDrawerItems = compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(({classes, admin, history, startEditAdmin}) => {
  return(
    <List>
      <Tooltip type={TooltipTypes.TIMECARD_MENU_ITEM} placement="right">
        <ListItem
          className={selectedStyle(classes, admin.selectedDrawerItem === "Time Cards")}
          button
          onClick={() => {
            resetAdmin(routes.TIMECARDS, startEditAdmin, history, "Time Cards");
            helpDispatch();
          }}
        >
          <ListItemIcon>
            <QueryBuilderIcon />
          </ListItemIcon>
          <ListItemText primary="Time Cards" />
        </ListItem>
      </Tooltip>
      <ListItem
        className={selectedStyle(classes, admin.selectedDrawerItem === "Receipts")}
        button
        onClick={() => resetAdmin(routes.RECEIPTS, startEditAdmin, history, "Receipts")}
      >
        <ListItemIcon>
          <ReceiptIcon />
        </ListItemIcon>
        <ListItemText primary="Receipts" />
      </ListItem>
    </List>
  );
});

export const ClientsDrawerItems = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(({history, startEditAdmin}) => {
  return(
    <List>
      <ListItem button onClick={() => resetAdmin(routes.CLIENTS, startEditAdmin, history)}>
        <ListItemIcon>
          <HomeIcon />
        </ListItemIcon>
        <ListItemText primary="Clients" />
      </ListItem>
    </List>
  );
});



// WEBPACK FOOTER //
// ./src/components/admin/MenuDrawerItems.jsx